import { createApi } from '@reduxjs/toolkit/query/react';

import { ENVIRONMENT } from '../../constants/env-constants';
import { createBearerBaseQuery } from '../../shared/rtk-bearer-base-query';

export const companiesApi = createApi({
  reducerPath: 'companies-api',
  baseQuery: createBearerBaseQuery(`${ENVIRONMENT.BACKEND_SERVER}/api/platform/companies`),
  endpoints: (build) => ({
    updateBillingData: build.mutation({
      query: (data) => ({
        url: '/update-billing-data',
        method: 'POST',
        body: data,
      }),
    }),
  }),
});

export const { useUpdateBillingDataMutation } = companiesApi;
